var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#6F7376"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.4394L20.1819 20.6213L19.1213 21.6819L17.75 20.3113V24.5H16.25V20.3097L14.8787 21.6819L13.818 20.6213L17 17.4394ZM17 9.5C19.6951 9.5 21.9158 11.5307 22.2156 14.1455C23.9643 14.6237 25.25 16.2242 25.25 18.125C25.25 20.2766 23.6027 22.0435 21.5005 22.2332L21.5007 20.7233C22.7725 20.541 23.75 19.4472 23.75 18.125C23.75 16.6753 22.5747 15.5 21.125 15.5C20.9684 15.5 20.815 15.5137 20.6665 15.5405C20.7212 15.2856 20.75 15.0212 20.75 14.75C20.75 12.6789 19.071 11 17 11C14.9289 11 13.25 12.6789 13.25 14.75C13.25 15.0212 13.2788 15.2856 13.334 15.54C13.185 15.5137 13.0316 15.5 12.875 15.5C11.4253 15.5 10.25 16.6753 10.25 18.125C10.25 19.4002 11.1593 20.463 12.3649 20.7005L12.5 20.7234L12.5003 22.2332C10.3977 22.0439 8.75 20.2769 8.75 18.125C8.75 16.2242 10.0357 14.6237 11.7849 14.1456C12.0842 11.5307 14.305 9.5 17 9.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.be8e72e9ceab43f1bf9a3ca5b45f1e72.svg";
export { ForwardRef as ReactComponent };